import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

/**
 * Limited mode strips expensive behaviour on very large documents, and dragging table rows and
 * columns is one of those behaviours.
 *
 * This only covers *dragging*. The row and column drag handles keep rendering so that clicking one
 * still selects the row/column and opens its menu.
 *
 * Limited mode can flip during a session — `false -> true` on any transaction as content loads, and
 * `true -> false` on a `replaceDocument` transaction — so callers must re-evaluate at runtime rather
 * than only when they first mount.
 */
export const isDragAndDropDisabledInLimitedMode = (
	limitedModeEnabled: boolean | undefined,
): boolean => !!limitedModeEnabled && isExperimentEnabled('platform_editor_table_limited_mode');
